module.exports = __webpack_public_path__ + "img/mobile_laptop.f1824fb2.png";